import { Component, OnInit, Renderer2 } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { EMPTY, catchError, switchMap } from 'rxjs';
import { ForeignParkingProcessClient, PaymentFailedDTO } from 'src/app/base/models/models.swagger.generated';

@Component({
  selector: 'app-payment-failed',
  templateUrl: './payment-failed.component.html',
  styleUrls: ['./payment-failed.component.scss'],
  imports: [TranslateModule]
})
export class PaymentFailedComponent implements OnInit {
  constructor(private renderer: Renderer2, private route: ActivatedRoute,
    private foreignParkingProcessClient: ForeignParkingProcessClient
  ) { }

  ngOnInit() {
    this.renderer.addClass(document.body, 'body-login');

    this.route.paramMap.pipe(
      switchMap(params => {
        const altPaymentIdent = params.get('ident');
        if (!altPaymentIdent) {
          return EMPTY;
        }

        return this.foreignParkingProcessClient.paymentFailed(
          new PaymentFailedDTO({ altPaymentIdent }),
        );
      }),
      catchError(() => EMPTY)
    ).subscribe();
  }

}
